module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "CN"
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text1#toc1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text1#toc1"
    }
  }, [_vm._v("Setting the Stage")])]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "toc_marker-3-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text1#toc2"
    }
  }, [_vm._v("A Change in Hearing")])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("“I feel crowded.” This was the response by a young woman to a sermon zealously preached in my recent seminary course entitled “Preaching the Sermon.” Her comment was not an unusual one; similar sermon responses throughout the term included these:")]), _vm._v(" "), _c('p', {
    staticClass: "LU-1ST"
  }, [_vm._v("“I felt emotionally manipulated.”")]), _vm._v(" "), _c('p', {
    staticClass: "LU"
  }, [_vm._v("“I don’t like it when preachers say, ‘Now I know what you’re thinking. . . .’ You don’t know what I’m thinking!”")]), _vm._v(" "), _c('p', {
    staticClass: "LU"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You ")]), _vm._v("were into the [biblical] story, but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I ")]), _vm._v("really don’t know it.”")]), _vm._v(" "), _c('p', {
    staticClass: "LU"
  }, [_vm._v("“There was no place for a differing opinion.”")]), _vm._v(" "), _c('p', {
    staticClass: "LU"
  }, [_vm._v("“Let me make my own decisions.”")]), _vm._v(" "), _c('p', {
    staticClass: "LU"
  }, [_vm._v("“It was too much; I had to tune you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "LU"
  }, [_vm._v("“The bigger you got, the smaller I felt.”")]), _vm._v(" "), _c('p', {
    staticClass: "LU-LAST"
  }, [_vm._v("“I kept backing up, but you kept moving forward.”")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("One student’s astute critique expressed the overall ethos of classroom listening: “There was no room for me in the sermon.” This ethos can be described as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("distance.")])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Distance ")]), _vm._v("in preaching can be described as a “psychic” separation, holding hearers “at bay,” keeping them from “direct participation” in a biblical text via the sermon’s form, technique, style, and delivery. Distance can be contrasted with “nearness,” or “participation,” which draws the hearer into the sermon. This functional definition of distance involves the psychic, aesthetic, spatial, and critical relationship between the sermon and the hearer. Distance in the sermon is created by the posture of the hearer, the structure and content of the sermon, the form, content, and style of the biblical text, and the role of the preacher with respect to individual hearers and the community.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In the last decade I have noticed a dramatic change in how sermons are listened to and heard in the classroom. Much of this shift can be described as a change of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("distance ")]), _vm._v("between the hearers and the sermon, between the hearers and the preacher, and between the hearers and the biblical text. My interest in distance in preaching arose from classroom settings toward the end of the last century. Having taught preaching and speech performance in both seminary and university settings, I was curious about the dramatic differences between the seminarians’ discussions of distance and those of university students. In the preaching classroom in seminary, student responses to sermons went like this: “You had me until the part. . . .” “You seemed distant.” “Reach out and talk to us.” “You never talked to me directly.” “I felt separated from you.” “Convince me!” “Draw me in.” “I want you to overwhelm me!” By contrast, responses to performances of literature in speech performance classrooms at the university went like this: “You were too close for comfort; you forced me to back away.” “You overpowered the poem with your voice and gestures.” “Let the piece speak for itself.” “Don’t complete the story for us; let us do that ourselves.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1130-1",
      "id": "footnote-1130-1-backlink"
    }
  }, [_vm._v("1")])]), _vm._v(" In both the university and seminary settings, students viewed the listeners’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("participation ")]), _vm._v("as a positive element in the presentations by their peers, and they encouraged its use through elements of style and delivery. In a striking contrast, students of speech performance considered distance a necessary component of performance, something that allowed the audience to experience the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("work ")]), _vm._v("and not just the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("performer, ")]), _vm._v("whereas seminarians considered distance an obstacle between the preacher and the congregation — something that kept hearers from “drawing close to God’s Word.”")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In recent years I have become aware of a change in sermon responses in courses that emphasize both sermon construction and preaching “live” in front of the class. Comments expressing a desire to be drawn in, convinced, and overwhelmed have all but disappeared. Taking their place are requests calling for “room” in the preached sermon for the hearers’ own interpretations and experiences, and calling for a respect for the distance, or “space,” within which hearers can have their own responses and make their own decisions.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("This change in the hearers’ response to preaching, and the differences between the contexts of preaching and speech performance, prompted me to investigate in this book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("distance ")]), _vm._v("in the disciplines of aesthetics, performance studies, and homiletics. My aim is to contribute to a greater understanding of distance in the field of homiletics; equip teachers and students of preaching to return to the classroom with an informed ability to evaluate its function in sermon form, style, and delivery; and encourage preachers to acquire greater understanding and skill in the use of distance as they create and preach sermons. My hope is that this understanding, combined with ability, may provide today’s preacher with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("room ")]), _vm._v("to speak the gospel, and may provide today’s hearer with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("space ")]), _vm._v("within which to hear the gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "toc_marker-3-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text1#toc3"
    }
  }, [_vm._v("Proposal and Plan of the Book")])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("In this book I propose that distance as a hermeneutical tool and a dynamic in communication is vital to today’s hearing of the gospel and thus should be intentionally used in sermon form, style, and delivery. In placing Fred Craddock’s sermon method into conversation with speech performance studies, critical challenges made by postliberal homiletics, and more recent homiletical proposals by David Buttrick, Charles Bartow, and Jana Childers, I evaluate the “benefits of distance” for the message and the hearer in today’s preaching.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("After clarifying terms, I use the remainder of chapter 1 to describe Fred Craddock’s introduction of distance into the field of homiletics in his lectures at Yale Divinity School in 1978. In chapter 2, I explore aesthetic distance as a concept and dynamic in philosophy, speech performance, theater, and literary criticism. I trace distance from its beginnings as a universal aesthetic principle to its current understanding as a dynamic device in performance, rituals, and literature.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Against the backdrop of aesthetics, performance, and literature, chapter 3 discusses Craddock’s proposal that distance protects the integrity of the biblical text and preserves the dignity of the hearer. I argue that Craddock’s intentional use of distance is not a pragmatic pandering to the hearer, but is theologically warranted and morally justified with regard to the hearer and sermon style. Using excerpts from Craddock’s published sermons, and transcriptions from selected audio and video recordings, I analyze Craddock’s use of “distancing devices” in style and delivery that allow “room” for “free participation” and a “new hearing” of the gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In chapter 4, I discuss Mark Ellingsen’s and Charles Campbell’s respective postliberal homiletics, which provide a sharp contrast to Craddock’s understanding of distance. Although both Ellingsen and Campbell claim the“postliberal” label, I note their distinctively different uses of Hans Frei and George Lindbeck as a basis for their homiletical proposals. I then evaluate “absorption” in their respective sermon methods and models in light of the concept of distance — both in performance theory and in Craddock’s homiletical theory.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Chapter 5 concludes with a reevaluation of distance in light of postliberal challenges regarding the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("experience ")]), _vm._v("of the hearer and the change in hearers within the last thirty-­five years. I end by offering two of my sermons as illustrations of distancing, hoping to provide room for the biblical text and space for the hearers’ response.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Terms")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("I describe "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("distance ")]), _vm._v("throughout this project according to the varied understandings and uses of particular authors. Terms that are unique to particular writers — for example, “overhearing,” “indirect address,” “intratextuality,” and “ascriptive logic” — I define with respect to their specific proposals. Because of the interdisciplinary nature of this project, readers should be aware that terms have different meanings and uses in their respective fields. For clarity, I offer the following definitions of selected terms:")]), _vm._v(" "), _c('p', {
    staticClass: "L1"
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Sermon ")]), _vm._v("Webster’s dictionary defines "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sermon ")]), _vm._v("as “a religious discourse delivered in public” usually by clergy “as a part of a worship service.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1130-2",
      "id": "footnote-1130-2-backlink"
    }
  }, [_vm._v("2")])]), _vm._v(" In this project, the components of a sermon may include a biblical text, gospel message, the Holy Spirit, sermon text, manuscript, preacher, hearer, congregation, and context, depending on the homiletician being discussed. Webster’s second definition is “a written discourse delivered or intended for delivery of a sermon.” I will often refer to this second meaning of “sermon” as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sermon text. ")]), _vm._v("I will use both of these meanings of sermon throughout this project.")]), _vm._v(" "), _c('p', {
    staticClass: "L1"
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Performance ")]), _vm._v("In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Performance: Texts and Contexts, ")]), _vm._v("Carol Simpson Stern and Bruce Henderson describe performance as “a human activity, interactional in nature and involving symbolic forms and live bodies, which constitutes meaning, expression or affirming individual and cultural values.” They note Victor Turner’s tracing of the term to the Old French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("perfournir, ")]), _vm._v("meaning “to complete” or “to carry out thoroughly.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1130-3",
      "id": "footnote-1130-3-backlink"
    }
  }, [_vm._v("3")])]), _vm._v(" In its broadest sense, I will use “performance” in this project according to the Stern and Henderson description. When referring to the performance of a sermon or the performance of literature, I will use Webster’s first definition (“the act or process of carrying out something”) and the second definition (“a public presentation”) and Stern and Henderson’s description of the performance event (“the embodiment or enactment of the text”).")]), _vm._v(" "), _c('p', {
    staticClass: "L1"
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Text ")]), _vm._v("Webster’s dictionary provides three meanings of “text” that I will use in this project: “the original or printed words and form of a literary work”; “a verse or passage of Scripture chosen especially for the subject of a sermon”; and “the form and substance of something written or spoken.” Pertinent to sermons that are preached without the creation or use of a manuscript, Stern and Henderson note that a text “may be oral, written, gestural, or some combination of these, is repeatable and capable of having invisible boundaries placed around it, separating it from other external features.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1130-4",
      "id": "footnote-1130-4-backlink"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "L1"
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Sermon Text ")]), _vm._v("In this book I will refer to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sermon text ")]), _vm._v("as an artifact that has been written, recorded on audio-­ or videocassettes, or transcribed.")]), _vm._v(" "), _c('p', {
    staticClass: "L1"
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Oral Interpretation and Interpretation ")]), _vm._v("For the purposes of this project, we can describe "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oral interpretation ")]), _vm._v("as a practice and discipline and as “the interpretation of literature through the medium of performance.” Although the discipline became known as simply "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("interpretation, ")]), _vm._v("I will use its former title (“oral interpretation”) to distinguish it from interpretation in biblical studies and hermeneutics.")]), _vm._v(" "), _c('p', {
    staticClass: "L1"
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Performance Studies ")]), _vm._v("Stern and Henderson note that performance refers to continuums of human activity, “from individual role playing in everyday life to collective staged performances; from everyday life performances to artificial, stylized performances (such as plays); and from ordinary performances to extraordinary performances or from personal narrative to ecstatic trance. Performance embraces cultural and literary performance as well as performance art, which includes a variety of activity from aesthetic to political, individual to collective.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1130-5",
      "id": "footnote-1130-5-backlink"
    }
  }, [_vm._v("5")])]), _vm._v(" For the purpose of this project, I will use the term “performance studies” as it pertains to the study of the performance of texts and rituals.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "toc_marker-3-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brothers_Distance_in_Preaching_text1#toc4"
    }
  }, [_vm._v("Introducing Distance in Preaching")])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("Thirty-­five years ago, Fred Craddock took the podium as the Lyman Beecher lecturer for 1978 at Yale Divinity School. In his series of lectures, entitled “Overhearing the Gospel: The Illusion of Truth without Imagination,” he formally introduced the concept of distance to the field of homiletics."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1130-6",
      "id": "footnote-1130-6-backlink"
    }
  }, [_vm._v("6")])]), _vm._v(" Eclectically drawing on works by various authors, including philosophers Søren Kierkegaard and Paul Ricoeur, writers George Eliot and Thomas de Quincey, and representatives of the New Hermeneutic such as Robert Funk and Amos Wilder, Craddock created his proposal of distance as a function of “overhearing” Scripture, the sermon, and the gospel. In his final lecture, he summarizes his proposal:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("The modest proposal being offered here is that the listener’s experience of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("overhearing ")]), _vm._v("is a natural, effective, and at times life-­changing dynamic that belongs in the church’s classroom and sanctuary. And since it is also appropriate to the study, the transition from desk to pulpit or lectern is made less awkward and difficult. (p. 120; italics added)")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("Craddock’s proposal of “overhearing” begins and ends with a concern for the hearer. In defense of this concern, he says:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("The Christian tradition, biblical and extra-­biblical, came to us from those who "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("heard ")]), _vm._v("it, and we "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hear ")]), _vm._v("it and pass it on to other "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hearers. ")]), _vm._v("The stamp of listening and the listenability of the message is on it when we get it, and in telling it, we confirm that it is listenable. To give such attention to the listener is not a concession to “what they want to hear,” playing to the balcony or to the groundlings, nor is it an introduction to how to succeed as a speaker; it is no more or less than to describe the shape of the subject matter (it came from the listeners) and the nature of the occasion (to effect a hearing). (p. 121)")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("Having established the experience of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("listening ")]), _vm._v("as “the governing consideration” in the communicative event of preaching that “harnesses the imaginative, emotive, and cognitive powers” of the preacher, Craddock characterizes the “posture” of listening, called “overhearing,” as made up of two elements: distance and participation. Craddock describes the “benefits of distance” as twofold. The first function of distance in the sermon is that it preserves the “invaluable benefits” of the message.")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("For the message, distance preserves its objectivity as history, its continuity as tradition, and its integrity as a word that has existence prior to and apart from the individual listener. In other words, the distance between the message and the listener conveys the sense of the substantive nature and independence of the message, qualities that add to rather than detract from the persuasive and attention-­drawing power of the message. . . . This I am calling distance, a necessary dimension of the experience of overhearing that says to the listener, “You are sitting in on something that is of such significance that it could have gone on without you.” (pp. 121-22)")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("Whereas the first benefit of distance is the protection of the message, the second is a concern for the listener. Craddock continues:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("As for the benefit distance provides the listener, we have talked of the room the listener has, room in which to reflect, accept, reject, decide. As a listener, I must have that freedom, all the more so if the matter before me is of ultimate importance. (p. 122)")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("After describing the benefits that distance provides for the message and listener, Craddock concludes:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("The other element in the experience of overhearing is participation: free participation on the part of the hearer in the issues, the crises, the decision, the judgment, and the promise of the message. Participation means the listener overcomes the distance, not because the speaker “applied” everything, but because the listener identified with experiences and thoughts related in the message that were analogous to his own. . . . [T]he speaker who wants the listeners to overhear will preserve distance in narration, but the vocabulary, idiom, imagery, and descriptive detail will be such as will allow points or moments in the process at which the listener can “enter,” identify, be enrolled. (p. 123)")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("In Craddock’s proposal, the counterpart of distance is also its goal: “free participation” on the part of the hearer. Craddock’s proposal ends where it began, a concern for the hearer.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("To the audience at Yale Divinity School, Craddock introduced distance in preaching as an approach to a biblical text, as dynamics within particular biblical texts, and as intentional tactics in the creation, presentation, and delivery of a sermon. Across campus from where Craddock was speaking, in the Yale Repertory Theater’s archives, were the playbills from its American premiere of Bertolt Brecht’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Little Mahagonny. ")]), _vm._v("Eight years before Craddock proposed distance as an intentional separation of the congregation from the sermon, Brecht’s signature use of distancing through “alienation devices” pushed audience members away from emotional identifications with characters in order to see the play’s greater significance for social change."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1130-7",
      "id": "footnote-1130-7-backlink"
    }
  }, [_vm._v("7")])]), _vm._v(" (A decade later, homiletician David Buttrick would credit Brecht with having informed his use of distance in sermon moves and structures in order to address the changing consciousness of the hearer.) Nearby, housed in Yale’s Beinecke Rare Book and Manuscript Library, were scene and set designs for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Our Town ")]), _vm._v("by Thornton Wilder (1879-1975). In these sketches, an almost bare theater stage reflects a vision of providing “room for the audience’s imagination” through the removal of “obtrusive bric-­a-­brac.”"), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1130-8",
      "id": "footnote-1130-8-backlink"
    }
  }, [_vm._v("8")])]), _vm._v(" In his lectures, Craddock quotes Wilder as he encourages preachers to make “room” for the imagination instead of overcrowding sermons with too much description. And while Craddock was describing the hearers’ experience of distance in preaching as similar to that of an audience for a concert or play, across campus, shelved in Yale’s Sterling Memorial Library under “aesthetics,” was Edward Bullough’s seminal article entitled “ ‘Psychical Distance’ as a Factor in Art and an Aesthetic Principle.” Originally published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The British Journal of Psychology ")]), _vm._v("in 1912, that essay introduced the concept of “psychical distance,” which became a defining factor for the discussion of “aesthetic attitude” and “aesthetic experience” in philosophy, and of “aesthetic dynamics” between the work and audience in theater, music, literature, and the visual arts."), _c('span', {
    staticClass: "noteref"
  }, [_c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-1130-9",
      "id": "footnote-1130-9-backlink"
    }
  }, [_vm._v("9")])]), _vm._v(" Although Craddock’s proposal of distance may have been new to his homiletical audience, writers in the areas of philosophy, the performing arts, and literature were well acquainted with its use. It is to these disciplines that we now turn."), _c('span', {
    staticClass: "char-style-override-1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1130-1-backlink",
      "id": "footnote-1130-1"
    }
  }, [_vm._v("1")]), _vm._v(". The classroom experiences to which I refer were at Princeton Theological Seminary, Eastern Baptist Theological Seminary, University of South Florida, and The School of Communication, Northwestern University.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1130-2-backlink",
      "id": "footnote-1130-2"
    }
  }, [_vm._v("2")]), _vm._v(". All dictionary definitions are from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Webster’s Third New International Unabridged Dictionary ")]), _vm._v("(Chicago: Encyclopedia Britannica, 2002), noted as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Webster’s ")]), _vm._v("dictionary or simply "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Webster’s.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1130-3-backlink",
      "id": "footnote-1130-3"
    }
  }, [_vm._v("3")]), _vm._v(". Carol Simpson Stern and Bruce Henderson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Performance: Texts and Contexts ")]), _vm._v("(White Plains, NY: Longman Publishing, 1993), p. 546.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1130-4-backlink",
      "id": "footnote-1130-4"
    }
  }, [_vm._v("4")]), _vm._v(". Stern and Henderson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Performance, ")]), _vm._v("p. 547.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1130-5-backlink",
      "id": "footnote-1130-5"
    }
  }, [_vm._v("5")]), _vm._v(". Stern and Henderson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Performance, ")]), _vm._v("p. 546.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1130-6-backlink",
      "id": "footnote-1130-6"
    }
  }, [_vm._v("6")]), _vm._v(". Fred B. Craddock, “Overhearing the Gospel: The Illusion of Truth without Imagination,” Lyman Beecher Lectures, Yale Divinity School, New Haven, Connecticut, 1978; published as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Overhearing the Gospel: Preaching and Teaching the Faith to Persons Who Have Heard It All Before ")]), _vm._v("(Nashville: Abingdon, 1978). Hereafter, page references to this latter publication appear in parentheses in the text.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1130-7-backlink",
      "id": "footnote-1130-7"
    }
  }, [_vm._v("7")]), _vm._v(". Yale University, Yale Repertory Theatre: "), _c('span', {
    staticClass: "url",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("http://www.yale.edu")]), _vm._v(" (accessed February 2012).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1130-8-backlink",
      "id": "footnote-1130-8"
    }
  }, [_vm._v("8")]), _vm._v(". Thornton Wilder, preface to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Three Plays by Thornton Wilder: Our Town, The Skin of Our Teeth, The Matchmaker ")]), _vm._v("(New York: Bantam Books, 1961), p. xi; Thornton Wilder Society: "), _c('span', {
    staticClass: "url",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("http://www.thorntonwildersociety.com")]), _vm._v(" (accessed February 2012); Yale University, Beinecke Rare Book and Manuscript Library: "), _c('span', {
    staticClass: "url",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("http://www.yale.edu")]), _vm._v(" (accessed February 2012).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-1130-9-backlink",
      "id": "footnote-1130-9"
    }
  }, [_vm._v("9")]), _vm._v(". Edward Bullough, “ ‘Psychical Distance’ as a Factor in Art and an Aesthetic Principle,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The British Journal of Psychology ")]), _vm._v("5 (June 1912): 87-118; reprinted in Bullough, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetics: Lectures and Essays ")]), _vm._v("(Stanford: Stanford University Press, 1957); Orbis, Yale University Library Catalog: "), _c('span', {
    staticClass: "url",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("http://www.yale.edu")]), _vm._v(" (accessed February 2012).")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-432d8f0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Brothers_Distance_in_Preaching_text-2.vue
// module id = 69
// module chunks = 0